<app-hero [isOfferList]="false"></app-hero>
<div class="lg:py-0 pb-5 lg:pb-5 lg:max-w-[1440px] mx-auto mt-10">
	<div class="lg:hidden bg-mainColor rounded-[15px] w-full py-3 px-3 my-5">
		<p class="flex flex-row items-center text-center text-md text-white font-semibold">
			<img
				[ngSrc]="hostConfig.logoIcon()"
				[alt]="hostConfig.alt()"
				class="h-[55px] p-3"
				height="55"
				width="62"
				loading="lazy"
			/>
			Na rynku turystycznym od 1998 roku
		</p>
	</div>
	@for (item of sectionWWW$ | async; track $index) {
		<div class="px-2 mb-10">
			@switch (item.kind) {
				@case (SectionWWWKinds.NONE) {
					<app-main-standard
						[title]="item.name"
						[titleSuffix]="item.nameSuffix"
						[query]="item.link"
					></app-main-standard>
				}
				@case (SectionWWWKinds.BACKGROUND) {
					<app-main-highlighted
						[title]="item.name"
						[titleSuffix]="item.nameSuffix"
						[query]="item.link"
					></app-main-highlighted>
				}
				@case (SectionWWWKinds.LIST) {
					<app-main-compact
						[title]="item.name"
						[titleSuffix]="item.nameSuffix"
						[query]="item.link"
					></app-main-compact>
				}
				@case (SectionWWWKinds.HORIZONTAL) {
					<app-main-horizontal [title]="item.name" [titleSuffix]="item.nameSuffix" [query]="item.link">
					</app-main-horizontal>
				}
			}
		</div>
	}
</div>
